import { render, staticRenderFns } from "./ssr-detail-supp.vue?vue&type=template&id=620c69b4&scoped=true"
import script from "./ssr-detail-supp.vue?vue&type=script&lang=js"
export * from "./ssr-detail-supp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c69b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620c69b4')) {
      api.createRecord('620c69b4', component.options)
    } else {
      api.reload('620c69b4', component.options)
    }
    module.hot.accept("./ssr-detail-supp.vue?vue&type=template&id=620c69b4&scoped=true", function () {
      api.rerender('620c69b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/ssr-detail-supp.vue"
export default component.exports